import * as actions from './actions';

const postStatusModule = {
  namespaced: true,
  actions,
};

export default postStatusModule;
